import React, { useState } from "react"
import IconMinusCircle from "../../../assets/icons/icon-minus-circle.svg"
import IconInfo from "../../../assets/icons/icon-info-blue.svg"
import { resolveUrlForArticles } from "./utils/urlUtils"
import { interpolate, getCurrentUnixTimestamp } from "./utils/displayUtils"
import { CHECKLIST_KEY } from "./utils/memberApplicationChecklist"
import { EVENTS_URLS } from "./utils/constants/externalUrls"
import {
  AdditionalRequirementsSection,
  AdditionalRequirementsHeader,
  AdditionalRequirementsTitle,
  AdditionalRequirementsIcon,
  AdditionalRequirementsTitleText,
  AdditionalRequirementsCount,
  AdditionalRequirementsBody,
  AdditionalRequirementsDescription,
  AdditionalRequirementCard,
  AdditionalRequirementHeader,
  AdditionalRequirementIcon,
  AdditionalRequirementTitle,
  AdditionalRequirementDescription,
  AdditionalRequirementContent,
  AdditionalRequirementActions,
  AdditionalRequirementTextLink,
  ActionButton,
  ActionButtonText,
} from "./Styles/ProgressTracker.styles"

const iconForItem = item => {
  if (item.hasWarning) return IconMinusCircle
  return IconInfo
}

const ChecklistItem = ({ item, unixTimestamp }) => {
  const primaryHref =
    item.primaryLinkKind === "pat-search"
      ? interpolate(EVENTS_URLS.PAT_SEARCH, { unixTimestamp })
      : item.primaryLinkUrl
  const secondaryHref = item.secondaryLinkUrl
    ? resolveUrlForArticles(item.secondaryLinkUrl)
    : null

  return (
    <AdditionalRequirementCard hasWarning={item.hasWarning}>
      <AdditionalRequirementHeader>
        <AdditionalRequirementIcon src={iconForItem(item)} alt="" />
        <AdditionalRequirementTitle>{item.title}</AdditionalRequirementTitle>
      </AdditionalRequirementHeader>
      <AdditionalRequirementContent>
        <AdditionalRequirementDescription>
          {item.description}
        </AdditionalRequirementDescription>
        {(primaryHref || secondaryHref) && (
          <AdditionalRequirementActions>
            {item.primaryLinkText && primaryHref && (
              <ActionButton
                as="a"
                href={primaryHref}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ActionButtonText>{item.primaryLinkText}</ActionButtonText>
              </ActionButton>
            )}
            {item.secondaryLinkText && secondaryHref && (
              <AdditionalRequirementTextLink
                as="a"
                href={secondaryHref}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.secondaryLinkText}
              </AdditionalRequirementTextLink>
            )}
          </AdditionalRequirementActions>
        )}
      </AdditionalRequirementContent>
    </AdditionalRequirementCard>
  )
}

const AdditionalRequirementsList = ({ items = [] }) => {
  const [isExpanded, setIsExpanded] = useState(true)
  const unixTimestamp = getCurrentUnixTimestamp()

  if (items.length === 0) {
    return null
  }
  const orderedItems = [...items].sort((a, b) => {
    const order = [
      CHECKLIST_KEY.PAT,
      CHECKLIST_KEY.EXPERIENCE_CREDITS,
      CHECKLIST_KEY.EMPLOYMENT,
      CHECKLIST_KEY.AGE,
      CHECKLIST_KEY.GOOD_STANDING,
      CHECKLIST_KEY.ACCEPTABLE_PROGRESS,
    ]
    return order.indexOf(a.key) - order.indexOf(b.key)
  })

  return (
    <AdditionalRequirementsSection>
      <AdditionalRequirementsHeader onClick={() => setIsExpanded(!isExpanded)}>
        <AdditionalRequirementsTitle>
          <AdditionalRequirementsIcon
            style={{
              transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)",
            }}
          />
          <AdditionalRequirementsTitleText>
            Additional Requirements
          </AdditionalRequirementsTitleText>
        </AdditionalRequirementsTitle>
        <AdditionalRequirementsCount>
          {orderedItems.length}
        </AdditionalRequirementsCount>
      </AdditionalRequirementsHeader>

      {isExpanded && (
        <AdditionalRequirementsBody>
          <AdditionalRequirementsDescription>
            Additional requirements do not need to be completed in a specific
            level but must be completed before applying for PGA of America
            Membership.
          </AdditionalRequirementsDescription>

          {orderedItems.map(item => (
            <ChecklistItem
              key={item.key}
              item={item}
              unixTimestamp={unixTimestamp}
            />
          ))}
        </AdditionalRequirementsBody>
      )}
    </AdditionalRequirementsSection>
  )
}

export default AdditionalRequirementsList
